// extracted by mini-css-extract-plugin
export var fadeIn = "styles-module--fadeIn--HdBRx";
export var fadeInAndMoveUp = "styles-module--fadeInAndMoveUp--hcjKE";
export var grid = "styles-module--grid--ZXcHd";
export var scaleUp = "styles-module--scaleUp--gUJX9";
export var slideIn = "styles-module--slideIn--K3rsE";